// extracted by mini-css-extract-plugin
export var chip = "_3x-0";
export var filterDropdown = "_3x-5";
export var filterItem = "_3x-6";
export var icon = "_3x-1";
export var removeButton = "_3x-3";
export var removeIcon = "_3x-4";
export var separator = "_3x-2";